import { Component, OnInit } from '@angular/core';
import { ApiService } from "app/api.service";
import { Router } from '@angular/router';
import { JwtService } from 'app/jwt.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email: string = '';
  password: string = '';
  data: any;
  decodedToken:any;

  success = false;
  constructor(
    private router: Router,
    private apiService: ApiService,
    private jwtService: JwtService,
    private route: ActivatedRoute
  ) {}
  
  getQueryParameter(name:any) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  ngOnInit(): void {
    // this.companyLogin();
    // this.route.queryParams.subscribe(params => {
    //   const receivedData = params; // Use params to get the data
    //   console.log('Data received:', receivedData);

    //   localStorage.setItem('receivedData', JSON.stringify(receivedData));
    // });
  }

  // companyLogin(){

  //   window.addEventListener('message', (event) => {
  //     const receivedData = JSON.parse(event.data);
  //     // Log the received data to the console (for debugging purposes)
  //     console.log('Received data:', receivedData);
  
  //   });
  // }


  login(): void {
    const formData = {
      email: this.email,
      password: this.password
    };
    this.apiService.userlogin(formData).subscribe(
      (response) => {
        if (response.code === 200) {
          console.log("Login successful:", response);
          this.success = true;
          localStorage.setItem("token", JSON.stringify(response.token));
          localStorage.setItem("data", JSON.stringify(response.data));
          localStorage.setItem("accesslist", JSON.stringify(response.access_list));
          this.decodedToken = this.jwtService.decodeToken(response.token);
          console.log('Decoded Token:', this.decodedToken);
          this.router.navigate(["/login-dashboard"]);
        } else if (response.code === 203) {
          alert("Invalid credentials. Please check your email and password.");
        } else {
          alert("An error occurred: " + response.status);
        }
      },
      (error) => {
        console.error("Login failed:", error);
        alert("An error occurred during login. Please try again later.");
      }
    );
  }

  passwordFieldType: string = 'password';
  togglePasswordVisibility() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }
}
